import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import React from "react";

import { cn } from "./utils";

const surfaceVariants = cva("ds-surface", {
  defaultVariants: {
    padding: "md",
    variant: "default",
  },
  variants: {
    padding: {
      none: "ds-surface--padding-none",
      sm: "ds-surface--padding-sm",
      md: "ds-surface--padding-md",
      lg: "ds-surface--padding-lg",
    },
    variant: {
      default: "ds-surface--default",
      elevated: "ds-surface--elevated",
      subtle: "ds-surface--subtle",
    },
  },
});

export interface SurfaceProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof surfaceVariants> {}

const Surface = React.forwardRef<HTMLDivElement, SurfaceProps>(
  ({ children, className, padding, variant, ...props }, ref) => (
    <div
      className={cn(surfaceVariants({ padding, variant }), className)}
      ref={ref}
      {...props}
    >
      {children}
    </div>
  )
);

Surface.displayName = "Surface";

const Card = Surface;

export { Card, Surface, surfaceVariants };
